import React from 'react';
import { motion } from 'framer-motion';
export function DifferentiationBlock() {
  return <section className="w-full bg-cobalt/5 px-5 py-6 sm:py-10" data-id="element-75" data-mp="2ar8cfl3lfd8y">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.4
    }} className="mx-auto max-w-2xl text-center" data-id="element-76" data-mp="2at1jh1i4bzhh">
        <h2 className="font-serif-display text-xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-77" data-mp="1w114w0f4jen1">
          Online esistono migliaia di risorse gratuite. E allora perché scegliere CHIMICA VISIVA™?
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-ink/80 sm:mt-4 sm:text-base" data-id="element-78" data-mp="25snj85mrdtu0">
          Perché trovare una risorsa è solo il primo passo. Devi ancora verificarla, capire se è
          adatta ai tuoi studenti, modificarla, cercare ciò che manca e organizzare tutto prima
          della lezione.
        </p>
        <div className="mx-auto mt-5 max-w-lg rounded-xl bg-white p-4 shadow-sm sm:mt-6 sm:p-5" data-id="element-79" data-mp="18bou4w45eyim">
          <p className="text-sm font-bold text-cobalt-deep sm:text-base" data-id="element-80" data-mp="34ofi8oatztl3">
            CHIMICA VISIVA™ non nasce per aggiungere altri PDF alla tua cartella. Nasce per evitarti
            di doverli cercare ogni volta.
          </p>
        </div>
        <p className="mt-4 text-[13px] font-medium text-ink/60 sm:mt-5 sm:text-sm" data-id="element-81" data-mp="3jdv3jorlf6te">
          Tutto ciò che normalmente cerchi, selezioni e prepari separatamente, ora è riunito in un
          unico sistema.
        </p>
      </motion.div>
    </section>;
}